import { Row, Col, Typography, Checkbox, Select, Spin } from 'antd';
import React from 'react';

const { Text } = Typography;

const CustomQuestionFilter = ({ filterOptions, filterValues = {}, handleFilterChange }) => {
  const customQuestionList = filterOptions?.customQuestionList;
  const isLoading = customQuestionList === undefined;
  const questions = Array.isArray(customQuestionList) ? customQuestionList : [];

  const selectedCustomQuestions = filterValues.selectedCustomQuestions || [];

  const setQuestionValues = (labelKey, values) => {
    const updated = selectedCustomQuestions.filter((q) => q.labelKey !== labelKey);
    if (Array.isArray(values) && values.length > 0) {
      updated.push({ labelKey, values });
    } else if (typeof values === 'string' && values.length > 0) {
      updated.push({ labelKey, values: [values] });
    }
    handleFilterChange(updated, 'selectedCustomQuestions');
  };

  const toggleCheckboxValue = (labelKey, option) => {
    const existing = selectedCustomQuestions.find((q) => q.labelKey === labelKey);
    const current = existing?.values || [];
    const next = current.includes(option)
      ? current.filter((v) => v !== option)
      : [...current, option];
    setQuestionValues(labelKey, next);
  };

  if (isLoading) {
    return (
      <Row style={{ padding: '20px', justifyContent: 'center' }}>
        <Spin />
      </Row>
    );
  }

  if (questions.length === 0) {
    return (
      <Row style={{ padding: '20px' }}>
        <Col span={24}>
          <Text style={{ fontSize: '13px', color: '#4D566E' }}>
            No custom questions configured for this role.
          </Text>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]} style={{ padding: '10px' }}>
      <Col span={24}>
        <Text style={{ fontSize: '14px', color: '#4D566E' }}>
          Filter by candidate answers to your application form questions
        </Text>
      </Col>

      {questions.map((q) => {
        const found = selectedCustomQuestions.find((sel) => sel.labelKey === q.labelKey);
        const currentValues = found?.values || [];
        const useCheckboxes = q.type === 'CHECKBOXES' && (q.options?.length || 0) <= 6;
        const isMulti = q.type === 'CHECKBOXES' || q.type === 'MULTI_SELECT';

        return (
          <Col key={q.labelKey} span={24} style={{ padding: '12px', borderRadius: '8px' }}>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>
              {q.label}
            </Text>

            {useCheckboxes ? (
              <div style={{ marginTop: '8px' }}>
                {(q.options || []).map((option) => (
                  <div key={option} style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={currentValues.includes(option)}
                      onChange={() => toggleCheckboxValue(q.labelKey, option)}
                    />
                    <Text style={{ marginLeft: 8 }}>{option}</Text>
                  </div>
                ))}
              </div>
            ) : (
              <Select
                mode={isMulti ? 'multiple' : undefined}
                allowClear
                style={{ width: '100%' }}
                placeholder={`Select ${q.label}`}
                value={isMulti ? currentValues : (currentValues[0] || undefined)}
                onChange={(value) => setQuestionValues(q.labelKey, value)}
                options={(q.options || []).map((option) => ({ label: option, value: option }))}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
              />
            )}
          </Col>
        );
      })}
    </Row>
  );
};

export default CustomQuestionFilter;
